import React from 'react'
import {Icon} from '@chakra-ui/react'

const NumberAbsoluteIcon = (props) => {
    return (
        <Icon viewBox="0 0 20 20" {...props}>
            <circle cx="10" cy="10.0002" r="10" fill="#266BBF" />
            <path d="M6.58938 11.6722V10.5322L10.8854 5.60024H12.0014V10.7602H13.4054V11.6722H12.0014V14.0002H10.9934V11.6722H6.58938ZM7.59738 10.7602H10.9934V6.86024L7.59738 10.7602Z" />
        </Icon>
    )
}

export default NumberAbsoluteIcon
